'use client';
import styled from 'styled-components';

export const ContentWrapper = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
